'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxRequestMiddleware = require('./reduxRequestMiddleware');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_reduxRequestMiddleware).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/redux-request-middleware/dist/main/index.js
// module id = 529
// module chunks = 0